import {isEmpty} from 'ramda';

/** Same shape as google.maps.LatLngLiteral, kept local so the util needs no Maps API types. */
export type RoutePoint = {lat: number; lng: number};

type RouteBounds = {north: number; south: number; east: number; west: number};

export const getRouteBounds = (path: RoutePoint[]) => {
  if (isEmpty(path)) {
    return null;
  }

  return path.reduce<RouteBounds>(
    (bounds, point) => ({
      north: Math.max(bounds.north, point.lat),
      south: Math.min(bounds.south, point.lat),
      east: Math.max(bounds.east, point.lng),
      west: Math.min(bounds.west, point.lng),
    }),
    {north: -90, south: 90, east: -180, west: 180}
  );
};
